export default __webpack_public_path__ + "static/media/102-desktop.2f9fe902.jpg";